import React from 'react';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';

const ManageUsers : React.FC<RouteConfigComponentProps> = ({route}) => renderRoutes(route?.routes)

export default ManageUsers;